import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { JobStatus } from "../store/types";

interface JobsMatrixLegendProps {
    jobStatuses: JobStatus[];
}

// Map the stable backend status code to a translation key so the legend text
// is localized instead of showing the raw English name from the API.
const STATUS_CODE_LABEL_KEY: Record<string, string> = {
    QUALIFIED: "jobs-matrix_qualified",
    EXPIRED: "jobs-matrix_expired",
    NOT_QUALIFIED: "jobs-matrix_not-qualified",
};

// Qualified color: #388E3C
// Expired color: #E44B48

const getStatusIcon = (statusCode: string) => {
    switch (statusCode) {
        case "QUALIFIED":
            return (
                <Box sx={{backgroundColor: "#E8F5E9", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", padding: "4px"}}>
                    <CheckOutlinedIcon sx={{ fontSize: 20, color: "#388E3C" }} />
                </Box>
            );
        case "EXPIRED":
            return (
                <Box sx={{backgroundColor: "#F9DEDC", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", padding: "4px"}}>
                    <AssignmentLateOutlinedIcon sx={{ fontSize: 20, color: "#E44B48" }} />
                </Box>
            );
        default:
            return null;
    }
};

const JobsMatrixLegend: React.FC<JobsMatrixLegendProps> = ({ jobStatuses }) => {
    const { t } = useTranslation();
    // Filter to show only QUALIFIED and EXPIRED statuses
    const visibleStatuses = jobStatuses.filter(
        (status) => status.code === "QUALIFIED" || status.code === "EXPIRED"
    );

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                padding: "8px 16px",
            }}
        >
            {/* <Typography
                sx={{
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#49454F",
                }}
            >
                Legend:
            </Typography> */}
            {visibleStatuses.map((status) => (
                <Box
                    key={status.id}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    {getStatusIcon(status.code)}
                    <Typography
                        sx={{
                            fontFamily: "Roboto",
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#1C1B1F",
                        }}
                    >
                        {STATUS_CODE_LABEL_KEY[status.code]
                            ? t(STATUS_CODE_LABEL_KEY[status.code])
                            : status.name}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default JobsMatrixLegend;
